import React from "react";
import { connect } from "react-redux";
import { FormattedMessage, injectIntl } from "react-intl";
import { UncontrolledTooltip, Button } from "reactstrap";
import Paginator from "../../sub/Paginator";
import { Tooltip } from "reactstrap";
import Util from "../../../util/Util";
import DateUtil from "../../../util/DateUtil";
import UserAddModal from "../../users/UserAddModal";

class CompanyListingUserModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      modal: null,
      nameFilter: "",
    };
    this.paginator = new Paginator(this);
  }

  stopEvent(e) {
    e.stopPropagation();
  }

  resetSearchFields() {
    this.setState({
      nameFilter: "",
    });
  }

  areResultsFiltered = () => {
    if (!Util.emptyString(this.state.nameFilter)) {
      return true;
    } else {
      return false;
    }
  };

  openUsersAddModal(company, user, users) {
    this.setState({
      modal: (
        <UserAddModal
          company={company}
          user={user}
          users={users}
          close={() => this.closeModal()}
        />
      ),
    });
  }

  closeModal() {
    this.setState({ modal: null });
  }

  onChange(field, value) {
    this.setState({ [field]: value });
  }
  render() {
    let resetSearchButton = () => {
      let button = (
        <React.Fragment>
          <button className="btn btn-outline-secondary ml-3 mr-auto" disabled>
            <i className="fa fa-filter" />
          </button>
        </React.Fragment>
      );
      if (this.areResultsFiltered() && !disableFormInput) {
        return (
          <React.Fragment>
            <button
              id="searchFilterBtn"
              className="btn btn-warning ml-3 mr-auto"
              onClick={() => this.resetSearchFields()}
            >
              <i className="fa fa-filter" />
            </button>
            <Tooltip placement="bottom" target="searchFilterBtn">
              <FormattedMessage id="Remove.Filter" />
            </Tooltip>
          </React.Fragment>
        );
      } else {
        return button;
      }
    };
    this.paginator.init();

    let disableFormInput = this.paginator.paginationIndex !== 1 ? true : false;

    var users = Object.values(this.props.user).filter(
      (items) => items.company_id === this.props.company._id,
    );
    var usersNode =
      users.length > 0 &&
      users.map((user) => {
        if (this.state.nameFilter && this.state.nameFilter !== "") {
          if (
            user.name
              .toUpperCase()
              .indexOf(this.state.nameFilter.toUpperCase()) === -1 &&
            user.first_name
              .toUpperCase()
              .indexOf(this.state.nameFilter.toUpperCase()) === -1
          )
            return null;
        }

        if (!this.paginator.keep()) return null;

        var UserRole = <FormattedMessage id={"Role." + user.role} />;

        return (
          <tr className="tre4coll d-flex" key={user._id}>
            <td className="col-2">{this.props.company.name}</td>
            <td className="col-3 text-center">
              {user.name + " " + user.first_name}
            </td>
            <td className="col-1 text-center">{UserRole}</td>
            <td className="col-2 text-center">
              {user.createdAt !== undefined && DateUtil.toDate(user.createdAt)}
            </td>
            <td className="col-2 text-center">
              {user.updatedAt !== undefined && DateUtil.toDate(user.updatedAt)}
            </td>
            <td className="col-2 text-center">
              <Button
                color={"success"}
                style={{ borderRadius: 40 }}
                onClick={(e) =>
                  this.openUsersAddModal(this.props.company, user, users)
                }
              >
                <UncontrolledTooltip
                  delay={{ show: 0, hide: 0 }}
                  placement="top"
                  target={"edit" + user._id}
                >
                  <FormattedMessage id="Edit.User" />
                </UncontrolledTooltip>
                <i id={"edit" + user._id} className="fa fa-edit  text-white" />
              </Button>
            </td>
          </tr>
        );
      });

    // if (!this.paginator.keep()) return null;

    return (
      <React.Fragment>
        <div className="modal-bg show" onClick={() => this.props.close()}>
          <div className="modal fade show">
            <div
              className="modal-dialog modal-xl"
              role="document"
              onClick={(e) => this.stopEvent(e)}
            >
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">
                    <FormattedMessage id="Users" />
                  </h5>
                  <button
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                    onClick={() => this.props.close()}
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>

                <div className="modal-body">
                  <div className="row search-filters">
                    <div className="col-12">
                      <div className="card">
                        <div className="card-body">
                          <div className="form-inline">
                            <input
                              id="search_name"
                              className="form-control"
                              onChange={(e) =>
                                this.onChange("nameFilter", e.target.value)
                              }
                              placeholder={
                                this.props.intl.formatMessage({
                                  id: "Name",
                                }) +
                                " " +
                                this.props.intl.formatMessage({
                                  id: "Or",
                                }) +
                                " " +
                                this.props.intl.formatMessage({
                                  id: "First.Name",
                                })
                              }
                              //   disabled={disableFormInput}
                              value={this.state.nameFilter}
                              disabled={disableFormInput}
                            />
                            {resetSearchButton()}
                            <button
                              className="btn btn-info ml-auto"
                              onClick={(e) =>
                                this.openUsersAddModal(
                                  this.props.company,
                                  null,
                                  users,
                                )
                              }
                            >
                              <FormattedMessage id="User.Add" />
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <table className="table tablee4coll">
                    <thead>
                      <tr className="d-flex">
                        <th className="col-2">
                          <FormattedMessage id="Menu.SuperAdmin.Company" />
                        </th>
                        <th className="col-3 text-center">
                          <FormattedMessage id="Name" />{" "}
                          <FormattedMessage id="First.Name" />
                        </th>
                        <th className="col-1 text-center">
                          <FormattedMessage id="Role" />
                        </th>
                        <th className="col-2 text-center">
                          <FormattedMessage id="Creation.Date" />
                        </th>
                        <th className="col-2 text-center">
                          <FormattedMessage id="Last.Update" />
                        </th>
                        <th className="col-2 text-center">
                          <FormattedMessage id="Actions" />
                        </th>
                      </tr>
                    </thead>

                    <tbody>{usersNode}</tbody>
                  </table>
                </div>
                {this.paginator.render()}

                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-info"
                    onClick={() => this.props.close()}
                  >
                    <FormattedMessage id="Close" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        {this.state.modal}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.user,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    //
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(CompanyListingUserModal));
